<template>
  <!-- ════ FOOTER ════ -->
  <footer>
    <div class="footer-top">
      <div class="footer-logo">
        <img src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/logo-lockup.png" alt="Kellogg's Cocoa Loops × Wonka">
        <a href="https://www.wkkellogg.com/where-to-buy#/US/any/products/~/~?dtr-selectedFilter={%22tags%22:%22Froot%20Loops%22}"
          target="_blank" rel="noopener" class="btn-gold footer-buy">Where to Buy<svg class="btn-icon" width="15"
            height="15" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
            <path d="M2.5 8H13M9.5 4.5L13 8L9.5 11.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round"></path>
          </svg></a>
      </div>
      <div class="footer-nav">
        <a href="http://snipp.us/!cuYZN" target="_blank" rel="noopener">Official Rules</a>
        <a href="javascript:void(0)" class="js-pd-open" data-pd-tab="grand">Prize Details</a>
        <a href="javascript:void(0)" class="js-pp-open">Participating Products</a>
        <a href="https://www.wkkellogg.com/contact-us" target="_blank" rel="noopener">Contact Us</a>
        <a nohref='nohref' class='track ot-sdk-show-settings' style='cursor: pointer'>Cookie Preferences</a>
        <a href="https://www.wkkellogg.com/privacy-notice" target="_blank" rel="noopener">Privacy Notice</a>
        <a href="https://www.wkkellogg.com/us-privacy-notice" target="_blank" rel="noopener">USA Privacy</a>
        <a href="https://www.wkkellogg.com/usage-terms" target="_blank" rel="noopener">Terms of Use</a>
        <a href="https://www.wkkellogg.com/do-not-share-or-sell-my-personal-information" target="_blank"
          rel="noopener">Do Not Sell or Share My Personal Information</a>
        <a href="https://www.wkkellogg.com/accessibility" target="_blank" rel="noopener">Accessibility</a>
      </div>
      <div class="footer-social">
        <span class="footer-social-label">Follow Us</span>
        <div class="footer-social-icons">
          <a href="https://www.instagram.com/frootloops" target="_blank" rel="noopener" aria-label="Instagram"><img
              src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/instagram.png" alt="Instagram"></a>
          <a href="https://x.com/frootloops" target="_blank" rel="noopener" aria-label="X"><img
              src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/x.png" alt="X"></a>
          <a href="https://www.facebook.com/frootloops" target="_blank" rel="noopener" aria-label="Facebook"><img
              src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/facebook.png" alt="Facebook"></a>
          <a href="https://www.youtube.com/c/FrootLoops" target="_blank" rel="noopener" aria-label="YouTube"><img
              src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/youtube.png" alt="YouTube"></a>
        </div>
      </div>
    </div>
  </footer>
  <div class="legal-band">
    <p><strong>KELLOGG’S<sup>®</sup> COCOA LOOPS WONKA™ GOLDEN TICKET SWEEPSTAKES</strong><br /><br />
      No Purchase Necessary. Open to legal residents of the fifty (50) United States and District of Columbia who are 18 years of age or older at time of entry. Begins at 12:00:00 AM (ET) on 8/17/26 and ends at 11:59:59 PM (ET) 12/31/26. For entry methods including no purchase necessary entry, prize details, odds of winning and complete Official Rules, go to <a href="https://www.wkkelloggwonka.com/" target="_blank" rel="noopener" style="color: var(--gold);">www.wkkelloggwonka.com</a>. Subject to complete Official Rules. Void where prohibited. Sponsor: WK Kellogg Co, One Kellogg Square, North Tower, Battle Creek, MI 49016.<br /><br />
      © 2026 WK Kellogg NA LLC<br /><br />
      Wonka™ is a registered trademark of Ferrero Group. ©2026 Ferrero Group</p>
  </div>
  <img v-if="showVerifyToucan" class="verify-toucan" src="https://snippcheck.blob.core.windows.net/files/WKKC_Golden_Ticket_2008937/images/toucan-sitting.png" alt="" aria-hidden="true">
</template>

<script>
//Younet chatbot code apprended in the body
export default {
  computed: {
    showVerifyToucan() {
      const path = this.$route && this.$route.path ? this.$route.path.toLowerCase() : '';
      return path !== '/' && path !== '/home' && path !== '/thanks';
    },
  },
  mounted() {
    // // Dynamically fetch the translated modelHash
    // const modelHash = this.$t('YounetmodelHash');
    // const modelImgurl = this.$t('YounetmodelIMg');
    // const scriptUrl = `https://widget.younet.ai/index.js?modelHash=${modelHash}&type=bubble&imgUrl=${modelImgurl}`;

    // // Dynamically create the script element
    // const script = document.createElement('script');
    // script.type = 'module';
    // script.src = scriptUrl;

    // // Append the script to the body
    // document.body.appendChild(script);

    const placeToucan = () => {
      const t = document.querySelector('.verify-toucan');
      const card = document.querySelector('.verify-card');
      if (!t || !card) return;

      const r = card.getBoundingClientRect();
      t.style.top = (r.top + window.scrollY - (t.offsetHeight - 50)) + 'px';
      t.style.left = (r.right + window.scrollX - t.offsetWidth + 2) + 'px';
    };

    const onResize = () => placeToucan();
    const onLoad = () => placeToucan();

    window.addEventListener('resize', onResize);
    window.addEventListener('load', onLoad);

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(placeToucan);
    }

    this._verifyToucanImg = document.querySelector('.verify-toucan');
    this._verifyToucanLoadListener = null;
    if (this._verifyToucanImg && !this._verifyToucanImg.complete) {
      this._verifyToucanLoadListener = placeToucan;
      this._verifyToucanImg.addEventListener('load', this._verifyToucanLoadListener);
    }

    this._verifyToucanObserver = new MutationObserver(() => placeToucan());
    this._verifyToucanObserver.observe(document.body, { childList: true, subtree: true });

    this._verifyToucanResizeListener = onResize;
    this._verifyToucanLoadWindowListener = onLoad;

    if (this.$watch) {
      this._verifyToucanRouteUnwatch = this.$watch('$route', () => {
        this.$nextTick(placeToucan);
      });
    }
  },
  beforeUnmount() {
    if (this._verifyToucanResizeListener) {
      window.removeEventListener('resize', this._verifyToucanResizeListener);
    }
    if (this._verifyToucanLoadWindowListener) {
      window.removeEventListener('load', this._verifyToucanLoadWindowListener);
    }
    if (this._verifyToucanImg && this._verifyToucanLoadListener) {
      this._verifyToucanImg.removeEventListener('load', this._verifyToucanLoadListener);
    }
    if (this._verifyToucanObserver) {
      this._verifyToucanObserver.disconnect();
    }
    if (typeof this._verifyToucanRouteUnwatch === 'function') {
      this._verifyToucanRouteUnwatch();
    }
  },
};
// Mobile nav (hamburger)
(function () {
  const toggle = document.querySelector('.nav-toggle');
  const menu = document.getElementById('mobile-menu');
  if (!toggle || !menu) return;
  function setOpen(open) {
    toggle.classList.toggle('open', open);
    menu.classList.toggle('open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
  }
  toggle.addEventListener('click', () => setOpen(!menu.classList.contains('open')));
  menu.querySelectorAll('a').forEach(a => a.addEventListener('click', () => setOpen(false)));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') setOpen(false); });
  window.addEventListener('resize', () => { if (window.innerWidth > 900) setOpen(false); });
  // Frost the nav bar only after the page is scrolled (transparent at top on load).
  const nav = document.querySelector('.main-nav');
  const onNavScroll = () => { if (nav) nav.classList.toggle('scrolled', window.scrollY > 8); };
  onNavScroll();
  window.addEventListener('scroll', onNavScroll, { passive: true });
})();
</script>


